import { render, staticRenderFns } from "./DownloadCenter.vue?vue&type=template&id=c81d7170&"
import script from "SKYXH/components/home/DownloadCenter.component?vue&type=script&lang=js&"
export * from "SKYXH/components/home/DownloadCenter.component?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports